module.exports = __webpack_public_path__ + "img/charging.91c01b73.svg";